import type UserAvailabilityCalendarView from 'owa-service/lib/contract/UserAvailabilityCalendarView';
import type { ScheduleInformation } from 'owa-graph-schema';
import convertWorkingHoursTypeToGetScheduleWorkingHours from './convertWorkingHoursTypeToGetScheduleWorkingHours';
import convertCalendarItemToScheduleItem from './convertCalendarItemToScheduleItem';

export default function convertUserAvailabilityCalendarViewToScheduleInformation(
    userAvailabilityView: UserAvailabilityCalendarView,
    attendee: string
): ScheduleInformation {
    const { MergedFreeBusy, Items, WorkingHours } = userAvailabilityView;

    return {
        availabilityView: MergedFreeBusy,
        error: null,
        scheduleId: attendee,
        scheduleItems: Items?.map(convertCalendarItemToScheduleItem),
        workingHours:
            WorkingHours && convertWorkingHoursTypeToGetScheduleWorkingHours(WorkingHours),
    };
}
